import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layouts
import { PublicLayout } from "@/components/layout/PublicLayout";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { ProtectedAdminRoute } from "@/components/admin/ProtectedAdminRoute";

// Public pages
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Captain from "@/pages/public/Captain";
import Officials from "@/pages/public/Officials";
import Announcements from "@/pages/public/Announcements";
import AnnouncementDetail from "@/pages/public/AnnouncementDetail";
import Programs from "@/pages/public/Programs";
import ProgramDetail from "@/pages/public/ProgramDetail";
import Projects from "@/pages/public/Projects";
import Accomplishments from "@/pages/public/Accomplishments";
import EServices from "@/pages/public/EServices";
import RequestDocument from "@/pages/public/RequestDocument";
import ReportConcern from "@/pages/public/ReportConcern";
import TrackRequest from "@/pages/public/TrackRequest";
import EmergencyContacts from "@/pages/public/EmergencyContacts";
import Contact from "@/pages/public/Contact";
import NotFound from "@/pages/public/NotFound";

// Admin pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ManageRequests from "@/pages/admin/ManageRequests";
import ManageConcerns from "@/pages/admin/ManageConcerns";
import ManageContent from "@/pages/admin/ManageContent";
import ExportReports from "@/pages/admin/ExportReports";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public site */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/captain" element={<Captain />} />
          <Route path="/officials" element={<Officials />} />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/announcements/:id" element={<AnnouncementDetail />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:id" element={<ProgramDetail />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/accomplishments" element={<Accomplishments />} />
          <Route path="/e-services" element={<EServices />} />
          <Route path="/request-document" element={<RequestDocument />} />
          <Route path="/report-concern" element={<ReportConcern />} />
          <Route path="/track-request" element={<TrackRequest />} />
          <Route path="/emergency" element={<EmergencyContacts />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Admin login (no layout) */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Protected admin */}
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="requests" element={<ManageRequests />} />
          <Route path="concerns" element={<ManageConcerns />} />
          <Route path="content/:type" element={<ManageContent />} />
          <Route path="export" element={<ExportReports />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
